import { render, staticRenderFns } from "./ActivitysRecords.vue?vue&type=template&id=1ad00c55&scoped=true"
import script from "./ActivitysRecords.vue?vue&type=script&lang=js"
export * from "./ActivitysRecords.vue?vue&type=script&lang=js"
import style0 from "./ActivitysRecords.vue?vue&type=style&index=0&id=1ad00c55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad00c55",
  null
  
)

export default component.exports